import { render } from "./SlotItemBtn.vue?vue&type=template&id=6a441990"
import script from "./SlotItemBtn.vue?vue&type=script&lang=js"
export * from "./SlotItemBtn.vue?vue&type=script&lang=js"

import "./SlotItemBtn.vue?vue&type=style&index=0&id=6a441990&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__